/**
 * Pill: chip redondeado (border-radius full) de 11px medium.
 *
 * Sprint 14 S14-06b. Replica `.cb-pill` del handoff
 * (`design-system/components.css` línea 489: "Pills (mas grandes, redondeadas)").
 *
 * DISTINCIÓN con `Badge`:
 * - `Badge` → cuadrado 9px uppercase. Etiqueta MICRO al lado de texto
 *   (ej. nombre del residente con "PENDIENTE" pequeño al costado).
 * - `Pill` → redondo 11px medium. Estado GRANDE de un objeto (chip de
 *   estado en card de vehículo, residente, cuota).
 *
 * Variantes alineadas con `Badge` para mantener el mapping semántico:
 * pending/success/warning/danger/info. Mismas paletas (`*-bg` + `*` del
 * handoff).
 *
 * Uso:
 *   <Pill variant="success">Aprobado</Pill>
 *   <Pill variant="pending">Pendiente validación</Pill>
 *   <Pill variant="danger">Suspendido</Pill>
 */
import type { ReactNode } from 'react';

type PillVariant = 'pending' | 'success' | 'warning' | 'danger' | 'info';

interface PillProps {
  variant: PillVariant;
  children: ReactNode;
  className?: string;
}

const VARIANT_CLASSES: Record<PillVariant, string> = {
  pending: 'bg-orange/20 text-orange',
  success: 'bg-state-success/15 text-state-success',
  warning: 'bg-state-warning/15 text-state-warning',
  danger: 'bg-state-danger/15 text-state-danger',
  info: 'bg-state-info/15 text-state-info',
};

export function Pill({ variant, children, className = '' }: PillProps) {
  // padding 4px 10px (var(--cb-space-1) var(--cb-space-3))
  // font-size 11px (--cb-text-sm), font-weight 500 (--cb-weight-medium)
  // border-radius 999px (--cb-radius-full)
  return (
    <span
      className={`inline-flex items-center text-sm font-medium px-3 py-1 rounded-full ${VARIANT_CLASSES[variant]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
